import React, { Fragment } from 'react'
import { useQuotation1, Quotation1Props } from './useQuotation1'
import styles from './Quotation1.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import QuotationCard from 'components/QuotationCard/QuotationCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const Quotation1: React.FC<Quotation1Props> = (props: Quotation1Props) => {
  const { quotationsData, isAr, t } = useQuotation1(props)

  return quotationsData && quotationsData.length ? (
    <section id='quotation1' className={styles.quotation1}>
      <TitleSection title={t('quotation')} />
      <div className='container'>
        <div className='row'>
          <div key={`quotation-${quotationsData[0].id}`} className='col-12'>
            <AnimatedContainer animation='jackInTheBox' extraCssClasses='h-100'>
              <QuotationCard
                title={
                  isAr ? quotationsData[0].titleAr : quotationsData[0].titleEn
                }
                description={
                  isAr
                    ? quotationsData[0].descriptionAr
                    : quotationsData[0].descriptionEn
                }
              />
            </AnimatedContainer>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Fragment />
  )
}

export default Quotation1
